import copyToClipboard from 'copy-to-clipboard';
import { useToast } from './useToast';

export const useCopyToClipboard = (): ((text: string) => void) => {
  const { showToast } = useToast();

  const copy = (text: string): void => {
    const success = copyToClipboard(text);
    if (success) {
      showToast('Copied to clipboard', 'success');
    } else {
      showToast('Could not copy. Please select and copy manually.', 'error');
    }
  };

  return copy;
};
